import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "25.579",
  height: "17.602",
  viewBox: "0 0 25.579 17.602"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  id: "icon_line_on",
  transform: "translate(2.116 2.12)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M2534.559-226.436l6.471,7.469,14.872-13.982",
    transform: "translate(-2534.559 232.949)",
    fill: "none",
    stroke: "#1eff44",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18.627",
  height: "18.282",
  viewBox: "0 0 18.627 18.282"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("g", {
  id: "icon_line_off",
  transform: "translate(2.121 2.121)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M2543.279-219.223l14.384-14.04",
    transform: "translate(-2543.279 233.263)",
    fill: "none",
    stroke: "#ff3d3d",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M2557.663-219.223l-14.384-14.04",
    transform: "translate(-2543.279 233.263)",
    fill: "none",
    stroke: "#ff3d3d",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
}